import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { SavingsSummary } from "../components/SavingsSummary";
import { getLeadById } from "../services/enpalForYouService";
import { Lead } from "../types";

const BONUS_LEAD_ID_KEY = "bonus_summary_lead_id";

export const BonusSummaryPage: React.FC = () => {
  const { id: urlId } = useParams<{ id: string }>();
  const [lead, setLead] = useState<Lead | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchLead = async (): Promise<void> => {
      // Determine which ID to use: URL param takes priority, otherwise use stored ID
      let leadId = urlId;

      if (urlId) {
        // Save the new ID to storage
        localStorage.setItem(BONUS_LEAD_ID_KEY, urlId);
      } else {
        // Try to get ID from storage
        leadId = localStorage.getItem(BONUS_LEAD_ID_KEY) || undefined;
      }

      if (!leadId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const leadData = await getLeadById(leadId);
        setLead(leadData);
      } catch {
        // Lead not found or error - will show empty state
      } finally {
        setLoading(false);
      }
    };

    fetchLead();
  }, [urlId]);

  if (loading) {
    return (
      <div className="page-shell mobile-safe-padding mobile-safe-top">
        <div className="flex min-h-[60vh] flex-col items-center justify-center">
          <LoadingSpinner />
          <p className="text-base text-enpal-stone-grey">Caricamento dati...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-shell mobile-safe-padding mobile-safe-top">
      <div className="page-header justify-center">
        <img src="/enpal-logo.png" alt="Enpal" className="h-10 w-auto" />
      </div>
      <div className="mx-auto max-w-4xl">
        <div className="enpal-card" data-testid="savings-summary-card">
          <h2 className="mb-3 text-2xl font-bold text-enpal-downriver sm:text-3xl">Riepilogo Risparmio</h2>
          <p className="mb-4 text-base text-enpal-stone-grey">
            Il tuo riepilogo personalizzato dei bonus e risparmi disponibili.
          </p>

          {lead && lead.bonusSummaryData && (
            <SavingsSummary
              productType={lead.productType}
              bonusSummaryData={lead.bonusSummaryData}
            />
          )}

          {lead && !lead.bonusSummaryData && (
            <div className="enpal-subtle-card text-center">
              <p className="text-base text-enpal-stone-grey">Nessun riepilogo risparmio disponibile.</p>
            </div>
          )}

          {!lead && (
            <div className="enpal-subtle-card text-center">
              <p className="text-base text-enpal-stone-grey">
                Purtroppo non abbiamo trovato nessuna richiesta associata al tuo account.
              </p>
              <p className="mt-4 text-base text-enpal-stone-grey">
                Per richiedere un preventivo e accedere al tuo riepilogo risparmio, compila il modulo sul nostro sito:
              </p>
              <a
                href="https://enpal.it/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mt-4"
              >
                Vai al modulo di richiesta
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
